import React from "react";
import { LegalPage } from "../components/LegalPage";

// Verbatim text from the official Cookie Policy (Effective Date 1.8.2026).
// DO NOT rewrite, summarise, or paraphrase any wording below.
const sections = [
  {
    id: "sec-1",
    number: "1.",
    title: "Introduction",
    body: [
      {
        type: "p",
        text: "This Cookie Policy explains how MiseOne (\u201Cwe\u201D, \u201Cour\u201D, or \u201Cus\u201D) uses cookies and similar technologies when you visit our website or use our online Services.",
      },
      { type: "p", text: "It should be read together with our Privacy Policy." },
    ],
  },
  {
    id: "sec-2",
    number: "2.",
    title: "What Are Cookies?",
    body: [
      {
        type: "p",
        text: "Cookies are small text files stored on your device when you visit a website.",
      },
      {
        type: "p",
        text: "They help websites function correctly, improve performance, remember preferences, and provide anonymous usage statistics.",
      },
      {
        type: "p",
        text: "Cookies cannot normally be used to directly identify you without additional information.",
      },
    ],
  },
  {
    id: "sec-3",
    number: "3.",
    title: "Types of Cookies We Use",
    body: [
      { type: "sub", number: "", title: "Essential Cookies" },
      {
        type: "p",
        text: "These cookies are necessary for the operation and security of the website and cannot be disabled through our cookie preferences.",
      },
      { type: "p", text: "Examples include:" },
      {
        type: "ul",
        items: [
          "user authentication;",
          "session management;",
          "security;",
          "load balancing.",
        ],
      },
      { type: "sub", number: "", title: "Functional Cookies" },
      {
        type: "p",
        text: "These cookies remember your preferences and improve your user experience.",
      },
      { type: "p", text: "Examples include:" },
      {
        type: "ul",
        items: [
          "language settings;",
          "login preferences;",
          "interface preferences.",
        ],
      },
      { type: "sub", number: "", title: "Analytics Cookies" },
      {
        type: "p",
        text: "Analytics cookies help us understand how visitors use our website so we can improve our Services.",
      },
      {
        type: "p",
        text: "Where required by law, these cookies are used only with your consent.",
      },
      { type: "sub", number: "", title: "Marketing Cookies" },
      {
        type: "p",
        text: "At the time of publication, MiseOne does not use marketing or advertising cookies.",
      },
      {
        type: "p",
        text: "If this changes in the future, this Cookie Policy will be updated and users will be asked for consent where required by applicable law.",
      },
    ],
  },
  {
    id: "sec-4",
    number: "4.",
    title: "Third-Party Cookies",
    body: [
      {
        type: "p",
        text: "Some cookies may be placed by trusted third-party providers used by MiseOne, such as analytics, hosting, or security services.",
      },
      {
        type: "p",
        text: "These providers process information in accordance with their own privacy policies.",
      },
    ],
  },
  {
    id: "sec-5",
    number: "5.",
    title: "Managing Cookies",
    body: [
      { type: "p", text: "You may:" },
      {
        type: "ul",
        items: [
          "accept cookies;",
          "reject non-essential cookies;",
          "change your cookie preferences at any time;",
          "delete cookies through your browser settings.",
        ],
      },
      {
        type: "p",
        text: "Please note that disabling certain cookies may affect the functionality of the website.",
      },
    ],
  },
  {
    id: "sec-6",
    number: "6.",
    title: "Changes to this Cookie Policy",
    body: [
      { type: "p", text: "We may update this Cookie Policy from time to time." },
      { type: "p", text: "The latest version will always be published on our website." },
      {
        type: "p",
        text: "Where required by law, we will request renewed consent for material changes affecting cookie usage.",
      },
    ],
  },
  {
    id: "sec-7",
    number: "7.",
    title: "Contact",
    body: [
      { type: "p", text: "If you have any questions regarding this Cookie Policy, please contact:" },
      { type: "p", text: "Email: info@miseone.eu" },
      { type: "p", text: "Website: www.miseone.eu" },
    ],
  },
];

export const CookiePolicy = () => (
  <LegalPage
    eyebrow="Legal"
    title="Cookie Policy"
    effectiveDate="1.8.2026"
    lastUpdated="1.8.2026"
    sections={sections}
    testId="cookies-page"
  />
);

export default CookiePolicy;
